module.exports = __webpack_public_path__ + "static/media/bolt-download3.39fac67c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bolt-download3.png
// module id = 349
// module chunks = 0